<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="newsletter-type-subscriber-form"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="newsletter-type-subscriber-email">
      Email <span v-if="id">(overrides the associated user email address)</span>
    </label>
    <input
      type="text"
      name="newsletter_type_subscriber[subscriber_email]"
      id="newsletter-type-subscriber-email"
      v-model="subscriber_email"
      class="form-control"
    />
  </div>

  <div class="form-group">
    <label for="newsletter-type-subscriber-accepted-at">
      Accepted At
    </label>
    <input
      type="datetime-local"
      name="newsletter_type_subscriber[accepted_at]"
      id="newsletter-type-subscriber-accepted-at"
      class="form-control"
      v-model="formattedAcceptedAt"
    />
  </div>

  <newsletter-type-picker
    :newsletterTypeId="newsletterTypeId"
    resource="newsletter_type_subscriber"
  ></newsletter-type-picker>

  <div class="form-group">
    <p class="alert alert-warning" role="alert">
      Users added to a subscription newsletter <strong>must</strong> have purchased subscription.
    </p>
  </div>

  <div v-if="newsletterTypeSubscriberId">
    <div class="form-group row">
      <div class="col-4">
        <label for="newsletter-type-subscriber-bounced-at">
          Bounced At
        </label>
        <input
          type="datetime-local"
          name="newsletter_type_subscriber[bounced_at]"
          id="newsletter-type-subscriber-bounced-at"
          class="form-control"
          v-model="formattedBouncedAt"
        />
      </div>
      <div class="col-4">
        <label for="newsletter-type-subscriber-pending-at">
          Pending At
        </label>
        <input
          type="datetime-local"
          name="newsletter_type_subscriber[pending_at]"
          id="newsletter-type-subscriber-pending-at"
          class="form-control"
          v-model="formattedPendingAt"
        />
      </div>
      <div class="col-4">
        <label for="newsletter-type-subscriber-unsubscribed-at">
          Unsubscribed At
        </label>
        <input
          type="datetime-local"
          name="newsletter_type_subscriber[unsubscribed_at]"
          id="newsletter-type-subscriber-unsubscribed-at"
          class="form-control"
          v-model="formattedUnsubscribedAt"
        />
      </div>
    </div>
  </div>
  </div>

  <div class="form-group">
    <label
      for="newsletter-type-subscriber-verified"
    >
      <input type="hidden" name="newsletter_type_subscriber[verified]" value="false" />
      <input
        type="checkbox"
        class="form-control-chx"
        id="newsletter-type-subscriber-verified"
        name="newsletter_type_subscriber[verified]"
        value="true"
      />

      Consider this subscriber verified?
    </label>
  </div>

  <div class="form-group">
    <button
      type="submit"
      class="form-control btn btn-primary btn-block"
    >
      {{ actionLbl }} Newsletter Type Subscription ({{getNewsletterTypeId}})
    </button>
    <button
      class="form-control btn btn-danger btn-block"
      v-if="newsletterTypeSubscriberId"
      v-on:click.prevent="deleteSubscriber"
    >
      Delete Newsletter Type Subscription
    </button>
  </div>
</form>
</template>

<script>
import NewsletterTypePicker from '@/components/NewsletterTypePicker'

import FlashStore from '@/stores/FlashStore'
import NewsletterTypeSubscriberStore from '@/stores/NewsletterTypeSubscriberStore'

export default {
  data () {
    let state = NewsletterTypeSubscriberStore.state
    state.accepted_at = new Date()

    return state
  },

  components: {
    'newsletter-type-picker': NewsletterTypePicker
  },

  computed: {
    actionLbl () {
      return this.newsletterTypeSubscriberId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return this.apiUrl(
        '/newsletter_type_subscribers' + (
          this.newsletterTypeSubscriberId ? ('/' + this.newsletterTypeSubscriberId) : ''
        ), true
      )
    },

    methodType () {
      return this.newsletterTypeSubscriberId ? 'PUT' : 'POST'
    },

    formattedAcceptedAt () {
      if (this.accepted_at) {
        return this.$root.dateTimeLocalFmt(this.accepted_at)
      }
    },

    formattedBouncedAt () {
      if (this.bounced_at) {
        return this.$root.dateTimeLocalFmt(this.bounced_at)
      }
    },

    formattedPendingAt () {
      if (this.pending_at) {
        return this.$root.dateTimeLocalFmt(this.pending_at)
      }
    },

    formattedUnsubscribedAt () {
      if (this.unsubscribed_at) {
        return this.$root.dateTimeLocalFmt(this.unsubscribed_at)
      }
    },

    getNewsletterTypeId () {
      return this.newsletterTypeId || this.relationships.newsletter_type.id
    },

    subscriberUrl () {
      return '/newsletter_type_subscribers/' + this.newsletterTypeSubscriberId
    }
  },

  props: [
    'newsletterTypeId',
    'newsletterTypeSubscriberId'
  ],

  created () {
    if (this.newsletterTypeSubscriberId) {
      this.get(this.subscriberUrl)
    }
  },

  methods: {
    get () {
      this.apiGet(
        this.subscriberUrl,
        NewsletterTypeSubscriberStore
      )
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    },

    deleteSubscriber () {
      if (prompt(
        'Are you sure you want to delete this subscriber?' +
          'Please enter their email address to confirm this action.',
        ''
      ) === this.subscriber_email) {
        this.$http.delete(
          this.apiUrl(this.subscriberUrl, true)
        ).then(() => {
          this.$router.push({
            name: 'newsletter_type_subscribers',
            params: {
              newsletterTypeId: this.getNewsletterTypeId
            }
          })

          FlashStore.error('Newsletter subscription deleted.')
        }, this.processErrors)
      } else {
        FlashStore.error('Subscriber deletion was not confirmed.')
      }
    },

    submit (ev) {
      this.bindSubmit(ev).then((resp) => {
        const newsletterTypeSubscriberId = resp.body.data.id

        this.$router.push({
          name: 'newsletter_type_subscriber',
          params: {
            newsletterTypeSubscriberId: newsletterTypeSubscriberId
          }
        })
      }, this.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriberForm.vue